/** Timestamp com fuso explícito: tela de operação sem fuso gera dúvida na hora errada. */
export function formatDateTime(value) {
  if (!value) {
    return '—';
  }
  return new Date(value).toLocaleString('pt-BR', { timeZoneName: 'short' });
}

const REPORTED_STATUS_LABELS = {
  healthy: 'saudável',
  degraded: 'degradado',
  unavailable: 'indisponível',
};

/**
 * O que o próprio Edge diz sobre si.
 *
 * É diferente do status da credencial no Core: um connector com credencial ativa
 * pode se declarar indisponível, por exemplo enquanto não tiver configuração
 * aplicada.
 */
export function formatReportedStatus(status) {
  if (!status) {
    return null;
  }
  return REPORTED_STATUS_LABELS[status] || status;
}
